import React, { useState, useRef, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import QrScanner from "qr-scanner";
import axiosInstance from "services/AxiosInstance";
import { toast } from "react-toastify";

const QRPreVisitantesModal = ({ isOpen, onClose, onScanSuccess }) => {
  const [scanning, setScanning] = useState(true);
  const videoRef = useRef(null);

  const handleResult = useCallback(
    (result) => {
      setScanning(false);
      try {
        // El QR puede contener la cédula directamente o un objeto JSON con la cédula
        let cedula;
        cedula = result.data.trim();
        console.log("---------------");
        console.log(cedula);
        console.log("---------------");

        if (!cedula || !/^\d+$/.test(cedula)) {
          toast.error(
            "Código QR inválido: debe contener solo números de cédula",
          );
          setScanning(true);
          return;
        }

        // Hacer GET para obtener los datos del pre-registro
        axiosInstance
          .get(`/api/v3/vigilancia/pre-registro-visitantes/?cedula=${cedula}`)
          .then((response) => {
            if (response.data && response.data.length > 0) {
              const preRegistro = response.data[0]; // Asumiendo que devuelve una lista
              onScanSuccess(preRegistro);
              onClose();
            } else {
              toast.error("No se encontraron datos para esta cédula");
              setScanning(true);
            }
          })
          .catch((err) => {
            console.error("Error al procesar QR:", err);
            toast.error("Error al procesar el código QR");
            setScanning(true);
          });
      } catch (err) {
        console.error("Error al procesar QR:", err);
        toast.error("Error al procesar el código QR");
        setScanning(true);
      }
    },
    [onClose, onScanSuccess],
  );

  useEffect(() => {
    if (isOpen) {
      setScanning(true);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && scanning && videoRef.current) {
      const qrScanner = new QrScanner(
        videoRef.current,
        (result) => handleResult(result),
        {
          onDecodeError: () => {}, // Suppress frequent "No QR code found" logs
          preferredCamera: "environment",
        },
      );
      qrScanner.start().catch((err) => {
        console.error("Error starting scanner:", err);
        toast.error("Error al iniciar la cámara");
      });
      return () => qrScanner.destroy();
    }
  }, [isOpen, scanning, handleResult]);

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Escanear QR de Pre-Registro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {scanning ? (
          <div>
            <p>Coloque el código QR frente a la cámara.</p>
            <video ref={videoRef} style={{ width: "100%" }} />
          </div>
        ) : (
          <p>Procesando...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default QRPreVisitantesModal;
